import type { ModernSubscription } from '../../types';

export function getSeatLimit(modernSubscription: ModernSubscription) {
  // They have paid for this many seats
  return modernSubscription._limits?.SeatCount !== undefined && modernSubscription._limits?.SeatCount !== null
    ? modernSubscription._limits?.SeatCount
    : 0;
}
